export default "__VITE_ASSET__fccd744f__"